export const osnCaretDownIcon = {
  data: `<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 1.17L0.80975 0.75H9.20525L9.5 1.155L5.27975 5.25H4.6595L0.5 1.17Z" fill="currentColor"/></svg>`,
  name: 'caret-down',
};
